import React, { useContext, useState } from 'react'
import { useQuery, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { LEGALISTS_QUERY } from 'graphql/User'
import { UPDATE_LEGAL_FORMALITY_MUTATION } from 'graphql/LegalFormalities'
import CentredLoader from 'components/CentredLoader'
import { UserType } from 'types/index'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'

const LegalistEdit = () => {
  const { t } = useTranslation()
  const { legalFormality } = useContext(CurrentLegalFormalityContext)

  const [legalistId, setLegalistId] = useState(legalFormality?.assignedUser?.id)
  const [editMode, setEditMode] = useState<boolean>(false)

  const { data, loading } = useQuery(LEGALISTS_QUERY)
  const [updateLegalFormality] = useMutation(UPDATE_LEGAL_FORMALITY_MUTATION)

  const assignUser = (userId: string) => {
    const id = parseInt(userId)
    const variables = { id: legalFormality.id, assignedUserId: id }
    updateLegalFormality({ variables }).then(() => {
      setEditMode(false)
      setLegalistId(id)
    })
  }

  const assignedUser = data?.legalists?.find(
    (user: UserType) => user.id == legalistId
  )

  return (
    <>
      {editMode && loading && <CentredLoader />}
      {editMode && !loading && (
        <select onChange={e => assignUser(e.target.value)} value={legalistId}>
          {data?.legalists?.map((user: UserType) => (
            <option value={user.id} key={user.id}>
              {user.email}
            </option>
          ))}
        </select>
      )}

      {!editMode && (
        <>
          <span>
            {assignedUser
              ? assignedUser.displayName
              : t('legalFormalities:show.misc.none')}
          </span>
          <span>
            <a onClick={() => setEditMode(true)}> edit</a>
          </span>
        </>
      )}
    </>
  )
}

export default LegalistEdit
